import { Carousel } from "antd";
import { useRef } from "react";
import { BsArrowLeftShort, BsArrowRightShort } from "react-icons/bs";
import better_health from "./images/better-health.webp";
import body_hair_care from "./images/body-hair-care.webp";
import desi_kits_boxes from "./images/desi-kits-boxes.webp";
import ready_to_eat from "./images/ready-to-eat.webp";
import rice_wheat_flour from "./images/rice-wheat-flours.webp";
import spices_condiments from "./images/spices-condiments.webp";
import pickles_sauces from "./images/suhana_red_chilli_sauce.webp";
import sweet_snacks from "./images/sweets-snacks.webp";
import { useWindowSize } from "react-use";
import MostLikedCategoryItem from "./MostLikedCategoryItem";

const MostLikesCategories = () => {
  const sliderRef = useRef(null);
  const { width } = useWindowSize();

  const categories = [
    {
      title: "READY TO EAT",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#0E7139",
      image: ready_to_eat,
    },
    {
      title: "SWEETS & SNACKS",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#fed304",
      image: sweet_snacks,
    },
    {
      title: "DESI KITS & BOXES",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#51B960",
      image: desi_kits_boxes,
    },
    {
      title: "BETTER HEALTH",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#fed304",
      image: better_health,
    },
    {
      title: "PICKLES & SAUCES",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#FF3939",
      image: pickles_sauces,
    },
    {
      title: "BODY & HAIR CARE",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#A4D232",
      image: body_hair_care,
    },
    {
      title: "GRAINS, OIL & FLOURS",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#4269F2",
      image: rice_wheat_flour,
    },
    {
      title: "SPICES & CONDIMENT",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#FF3939",
      image: spices_condiments,
    },
    {
      title: "DESI KITS & BOXES",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#51B960",
      image: desi_kits_boxes,
    },
    {
      title: "SPICES & CONDIMENT",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#FF3939",
      image: spices_condiments,
    },
    {
      title: "BODY & HAIR CARE",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#A4D232",
      image: body_hair_care,
    },
    {
      title: "SWEETS & SNACKS",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#fed304",
      image: sweet_snacks,
    },
    {
      title: "GRAINS, OIL & FLOURS",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#4269F2",
      image: rice_wheat_flour,
    },
    {
      title: "PICKLES & SAUCES",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#FF3939",
      image: pickles_sauces,
    },
    {
      title: "READY TO EAT",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#0E7139",
      image: ready_to_eat,
    },
    {
      title: "BETTER HEALTH",
      sub_title: "Sale up to 20%",
      btn_link: "/",
      color: "#fed304",
      image: better_health,
    },
  ];

  // Calculate items per slide based on screen width
  const getItemsPerSlide = () => {
    if (width >= 1200) return 8; // 4 columns x 2 rows
    if (width >= 992) return 6; // 3 columns x 2 rows
    if (width >= 768) return 4; // 2 columns x 2 rows
    if (width >= 576) return 2; // 1 column x 2 rows
    return 1; // 1 column x 1 row
  };

  const getColumnsPerRow = () => {
    if (width >= 1200) return 4;
    if (width >= 992) return 3;
    if (width >= 768) return 2;
    return 1;
  };

  const getRowsPerSlide = () => {
    if (width >= 576) return 2;
    return 1;
  };

  const itemsPerSlide = getItemsPerSlide();
  const columnsPerRow = getColumnsPerRow();
  const rowsPerSlide = getRowsPerSlide();

  // Group categories into slides
  const slides = [];
  for (let i = 0; i < categories.length; i += itemsPerSlide) {
    slides.push(categories.slice(i, i + itemsPerSlide));
  }

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div className="fs-2 fw-bold text-primary">Most Liked Categories</div>
        <div className="d-flex align-items-center">
          <div className="fw-bold text-primary me-2">See More</div>
          <BsArrowLeftShort
            size={25}
            role="button"
            onClick={() => {
              sliderRef.current.prev();
            }}
          />
          <BsArrowRightShort
            size={25}
            role="button"
            onClick={() => {
              sliderRef.current.next();
            }}
          />
        </div>
      </div>
      <Carousel ref={sliderRef} dots={false} infinite={true} draggable>
        {slides.map((slideItems, slideIndex) => (
          <div key={slideIndex}>
            <div className="row g-0">
              {Array.from({ length: rowsPerSlide }).map((_, rowIndex) => (
                <div key={rowIndex} className="row g-0">
                  {slideItems
                    .slice(
                      rowIndex * columnsPerRow,
                      (rowIndex + 1) * columnsPerRow,
                    )
                    .map((item, itemIndex) => (
                      <div
                        key={itemIndex}
                        className={`col-${12 / columnsPerRow}`}
                      >
                        <MostLikedCategoryItem {...item} />
                      </div>
                    ))}
                </div>
              ))}
            </div>
          </div>
        ))}
      </Carousel>
    </>
  );
};

export default MostLikesCategories;
